import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_NEWS_ITEM, GET_NEWS_ITEMS, UPDATE_NEWS_ITEM, ADD_COMMENT_ITEM, GET_COMMENTS, GET_LIKED_POSTS_BY_CURRENT_USER, GET_POST_LIKES } from "../actions";
import {
  getNewsItemsSuccess, getNewsItemsError,
  getNewsItemSuccess, getNewsItemError,
  updateNewsItemSuccess, updateNewsItemError,
  addCommentSuccess, addCommentError,
  getCommentsSuccess, getCommentsError,
  getLikedPostsByCurrentUserSuccess, getLikedPostsByCurrentUserError,
  getPostLikesSuccess, getPostLikesError
} from "./actions";
import LocalStorageService from "../../services/storage/LocalStorageService";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
const localStorageService = LocalStorageService.getService();

const GET_NEWS_ITEMS_ERROR = 'Show news items failed.';

const getLikedPostsByCurrentUserAsync = async (contactId) => {
  let obj;
  try {
    const responseObject = await centralApiAxios.get(`contacts/${contactId}/liked`);
    if (responseObject.data) {
      obj = {
        likedPostIds: responseObject.data.recordsLiked,
        message: null,
      };
    }
  } catch (err) {
    obj = {
      message: "Getting posts liked by current user fails."
    };
  }
  return obj;
}

function* getLikedPostsByCurrentUser({ payload }) {
  try {
    const resultReturned = yield call(getLikedPostsByCurrentUserAsync, payload.contactId);
    if (!resultReturned.message) {
      yield put(getLikedPostsByCurrentUserSuccess(resultReturned.likedPostIds));
    } else {
      yield put(getLikedPostsByCurrentUserError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getLikedPostsByCurrentUserError("Getting posts liked by current user fails."));
  }
}

const getPostLikesAsync = async (postId) => {
  try {
    const responseObject = await centralApiAxios.get(`posts/${postId}/likes`);
    if (responseObject.data) {
      return {
        likeCount: responseObject.data,
        message: null,
      };
    }
  } catch (err) {
    return {
      message: "Getting like count of post fails."
    }
  }
}

function* getPostLikes({ payload }) {
  try {
    const resultReturned = yield call(getPostLikesAsync, payload.postId);
    if (resultReturned) {
      if (!resultReturned.message) {
        yield put(getPostLikesSuccess(payload.postId, resultReturned.likeCount));
      } else {
        yield put(getPostLikesError(resultReturned.message));
      }
    }
  } catch (errorExp) {
    yield put(getPostLikesError("Get like count fails"));
  }
}

const getNewsItemsAsync = async (payload) => {
  centralApiAxios.defaults.headers.get['Content-Type'] = 'application/json';
  try {
    const queryParams = new URLSearchParams(window.location.search);
    const bypassCache = queryParams.get("bypassCache");
    const clearCache = queryParams.get("clearCache");

    const paramString = (bypassCache == null || bypassCache == undefined) ? "" : (`&bypassCache=${bypassCache}`);
    // eslint-disable-next-line
    const paramStringFull = (clearCache == null || clearCache == undefined) ? paramString : (`${paramString}&clearCache=${clearCache.toString()}`);

    const responseObject = await centralApiAxios.get(`news_items?trashed=false&pageNumber=${payload.pageNumber}`, getActivityHeadersUpdated(payload));
    if (responseObject.data) {
      return {
        newsItems: responseObject.data.items,
        message: null,
      };
    }
  } catch (err) {
    return {
      message: GET_NEWS_ITEMS_ERROR
    }
  }
}

const getNewsItemAsync = async (articleId) => {
  try {
    const responseObject = await centralApiAxios.get(`news_items/${articleId}`);
    return {
      newsItem: responseObject.data,
      message: null,
    };
  } catch (err) {
    return {
      message: GET_NEWS_ITEMS_ERROR
    }
  }
}


function* getNewsItems({ payload }) {
  try {
    const resultReturned = yield call(getNewsItemsAsync, payload);
    if (!resultReturned.message) {
      yield put(getNewsItemsSuccess(resultReturned.newsItems));
    } else {
      yield put(getNewsItemsError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getNewsItemsError(GET_NEWS_ITEMS_ERROR));
  }
}

function* getNewsItem({ payload }) {
  try {
    const resultReturned = yield call(getNewsItemAsync, payload.articleId);
    if (!resultReturned.message) {

      yield put(getNewsItemSuccess(resultReturned.newsItem));
    } else {
      yield put(getNewsItemError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getNewsItemError(GET_NEWS_ITEMS_ERROR));
  }
}


const updateNewsItemAsync = async (newsItem) => {
  try {
    const responseObject = await centralApiAxios.post("news_items", newsItem);
    if (responseObject.data) {
      return {
        newsItem: responseObject.data,
        message: null,
      };
    }
  } catch (err) {
    // alert(err);
    return {
      message: "Like action failed"
    }
  }
}

const updateLikeAsync = async (news_item, isLiked) => {
  try {

    let loggedInUserContactId = localStorageService.getUserInfo("user_contactId");
    var url = `posts/${news_item.aboutRecordId}/likes/${loggedInUserContactId}/${isLiked}`;

    const responseObject = await centralApiAxios.post(url);

    if (responseObject.status === 200) {
      return {
        message: null,
      };
    }
  } catch (err) {
    // alert(err);
    return {
      message: "Like action failed"
    }
  }
}

function* updateNewsItem({ payload }) {
  try {
    const updatedNewsItem = { ...payload.newsItem };
    let resultReturned = "";
    if (payload.isDelete) {
      updatedNewsItem.trashed = true;
      resultReturned = yield call(updateNewsItemAsync, updatedNewsItem);
    } else if (payload.isLiked) {
      resultReturned = yield call(updateLikeAsync, updatedNewsItem, payload.isLiked);
    } else if (payload.isLiked == false) {
      resultReturned = yield call(updateLikeAsync, updatedNewsItem, payload.isLiked);
    }
    if (resultReturned) {
      if (!resultReturned.message) {
        yield put(updateNewsItemSuccess(resultReturned.newsItem));
      } else {
        yield put(updateNewsItemError(resultReturned.message));
      }
    }
    else {
      yield put(updateNewsItemError(""));
    }
  } catch (errorExp) {
    yield put(updateNewsItemError("Like action failed."));
  }
}

const addCommentItemAsync = async (news_item, jsonComment, contactId) => {
  try {

    const postCreateRequest = {};
    postCreateRequest.CommentGuid = jsonComment.CommentGuid;
    postCreateRequest.Body = jsonComment.comment;
    postCreateRequest.CommentedBy = contactId;
    postCreateRequest.CommentedByDisplayName = jsonComment.displayName;
    postCreateRequest.CreatedDate = new Date();

    const responseObject = await centralApiAxios.post(`posts/${news_item.aboutRecordId}/comments`, postCreateRequest);

    if (responseObject.data) {
      return {
        newsItem: null,
        message: null,
      };
    }
  } catch (err) {
    return {
      message: "Comment add failed"
    }
  }
}

function* addCommentItem({ payload }) {
  try {
    const updatedNewsItem = { ...payload.newsItem };

    const resultReturned = yield call(addCommentItemAsync, updatedNewsItem, payload.comment, payload.contactId);
    if (!resultReturned.message) {
      yield put(addCommentSuccess(resultReturned.newsItem));
    } else {
      yield put(addCommentError(resultReturned.message));
    }
  } catch (errorExp) {
    console.log(errorExp);
    yield put(addCommentError("Comment add failed."));
  }
}

const getCommentItemAsync = async (postid) => {
  try {
    const responseObject = await centralApiAxios.get(`posts/${postid}/comments`);
    if (responseObject.data) {
      return {
        newsItem: responseObject.data,
        message: null,
      };
    }
  } catch (err) {
    // alert(err);
    return {
      message: "Comment add failed"
    }
  }
}

function* getComments({ payload }) {
  try {
    const resultReturned = yield call(getCommentItemAsync, payload.postId);
    if (!resultReturned.message) {
      yield put(getCommentsSuccess(resultReturned.newsItem));
    } else {
      yield put(getCommentsError(resultReturned.message));
    }
  } catch (errorExp) {
    console.log(errorExp);
    yield put(getCommentsError("Comment add failed."));
  }
}

export function* watchGetNewsItems() {
  yield takeEvery(GET_NEWS_ITEMS, getNewsItems);
}

export function* watchGetNewsItem() {
  yield takeEvery(GET_NEWS_ITEM, getNewsItem);
}

export function* watchGetPostLikes() {
  yield takeEvery(GET_POST_LIKES, getPostLikes);
}

export function* watchGetLikedPostsByCurrentUser() {
  yield takeEvery(GET_LIKED_POSTS_BY_CURRENT_USER, getLikedPostsByCurrentUser);
}

export function* watchUpdateNewsItem() {
  yield takeEvery(UPDATE_NEWS_ITEM, updateNewsItem);
}

export function* watchAddCommentItem() {
  yield takeEvery(ADD_COMMENT_ITEM, addCommentItem);
}

export function* watchGetComments() {
  yield takeEvery(GET_COMMENTS, getComments);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetNewsItems),
    fork(watchGetNewsItem),
    fork(watchUpdateNewsItem),
    fork(watchAddCommentItem),
    fork(watchGetComments),
    fork(watchGetLikedPostsByCurrentUser),
    fork(watchGetPostLikes)
  ]);
}
